import { useRef } from 'react';
import _useRootClose from '@restart/ui/useRootClose';
function useRootClose(onRootClose, options) {
  var ref = useRef(null);
  _useRootClose(ref, onRootClose, options);
  return ref;
}
export default useRootClose;